/* Claude Code: New Snippet: 2026-07-30: Auto-generate Table of Contents from article headings */
(function () {
  var container = document.getElementById('article-toc');
  if (!container) return;

  var content = document.querySelector('.article-template__content');
  if (!content) return;

  var headings = content.querySelectorAll('h2');
  if (headings.length < 3) {
    container.style.display = 'none';
    return;
  }

  var list = document.createElement('ul');
  list.className = 'article-toc__list';

  headings.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'section-' + (i + 1);
    }

    var li = document.createElement('li');
    li.className = 'article-toc__item';

    var a = document.createElement('a');
    a.className = 'article-toc__link';
    a.href = '#' + h.id;
    a.textContent = h.textContent;

    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(h.id);
      if (target) {
        var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + h.id);
      }
    });

    li.appendChild(a);
    list.appendChild(li);
  });

  container.appendChild(list);
  container.classList.add('is-collapsed');
  list.style.maxHeight = '0';

  /* Collapse/expand toggle */
  var title = container.querySelector('.article-toc__title');
  if (title) {
    title.addEventListener('click', function () {
      container.classList.toggle('is-collapsed');
      if (!container.classList.contains('is-collapsed')) {
        list.style.maxHeight = list.scrollHeight + 'px';
      }
    });
  }

  /* Scroll spy — highlight current section */
  var links = list.querySelectorAll('.article-toc__link');
  var ticking = false;

  function updateActive() {
    var scrollY = window.pageYOffset + 120;
    var active = null;

    headings.forEach(function (h, i) {
      if (h.offsetTop <= scrollY) {
        active = i;
      }
    });

    links.forEach(function (link, i) {
      link.classList.toggle('is-active', i === active);
    });

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateActive);
      ticking = true;
    }
  }, { passive: true });

  updateActive();
})();
